import { MouseButton } from '@/types/types';
import { ProductRenderer } from '../ProductRenderer';
import { CursorHandler } from './CursorHandler';
import { Object3D, Raycaster, Vector2 } from 'three';

export class Mouse {
	private mouse = new Vector2();
	private mouseDown = new Vector2();
	private raycaster = new Raycaster();
	private enabled = true;
	cursorHandler: CursorHandler;
	hoveredObject: Object3D | null = null;

	constructor(private renderer: ProductRenderer) {
		this.renderer = renderer;
		this.mouseMove = this.mouseMove.bind(this);
		this.onMouseDown = this.onMouseDown.bind(this);
		this.onMouseUp = this.onMouseUp.bind(this);

		this.cursorHandler = new CursorHandler(renderer, this);
	}

	init() {
		this.raycaster.layers.disableAll();

		this.renderer.canvas!.addEventListener('mousemove', this.mouseMove);
		this.renderer.canvas!.addEventListener('mousedown', this.onMouseDown);
		this.renderer.canvas!.addEventListener('mouseup', this.onMouseUp);
	}

	private mouseMove(event: MouseEvent) {
		event.preventDefault();
		if (!this.enabled) return;

		this.cursorHandler.setCursorType();
	}

	private onMouseDown(event: MouseEvent) {
		if (!this.enabled) return;

		this.mouseDown.copy(this.mouse);

		if (event.button === MouseButton.MIDDLE) {
			return;
		}
		if (event.button === MouseButton.RIGHT) {
			return;
		}
	}

	private onMouseUp(event: MouseEvent) {
		event.preventDefault();
		if (!this.enabled) return;
	}
}
